module.exports = __webpack_public_path__ + "img/99.e0d07666.png";